export const roleChangeValidation = (role) => {
	if (role.role === 'manager' && !role.branchId) {
		return { isValid: false, message: 'Branch name is required for managers' };
	}

	if (!role.role) {
		return { isValid: false, message: 'Select different role than current' };
	}

	return { isValid: true };
};
